module.exports = __webpack_public_path__ + "static/media/tatu-peba_thumb.308d47b1.jpg";